import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from '../pages/Auth/Login/Login';
import SignUp from '../pages/Auth/SignUp';
import ChangePassword from '../pages/Auth/Login/ChangePassword';
import ForgetPassword from '../pages/Auth/Login/ForgetPassword';
import WelcomeScreen from '../pages/Auth';
import MainLayout from '../layout/mainLayout';

import RequireJWT from './component/RequireJWT';
import RequireAuth from './component/RequireAuth';
import NotFound from './component/NotFound';
import RequireNoAuth from './component/RequireNoAuth';
import RouteStyleOne from './component/RouteStyleOne';

import Sample from '../pages/Sample/Sample';
import Branch from '../pages/Branch';
import Department from '../pages/Department';
import Role from '../pages/Role';
import User from '../pages/User';
import CommitteeConfig from '../pages/CommitteeConfig';
import BulkUser from '../pages/User/BulkUser';
import MyCalendar from '../pages/MeetingManagement/MyCalandar';
import ManageCommittee from '../pages/MeetingManagement/ManageCommittee';
// import ChatLayout from '../pages/Chat/ChatLayout';
import ChatLayout from '../pages/Chat/meeting-chat';
import AltSignatory from '../pages/MeetingManagement/AltSignatory/AltSignatory';
import Meeting from '../pages/MeetingManagement/Meeting';
import LeaveManagement from '../pages/LeaveManagement/LeaveManagement';
import SettingsLayout from '../pages/Settings';
import AltSignatoryRellocation from '../pages/MeetingManagement/AltSignatory/AltSignatoryRellocation';

import MeetingDocsApprovalReport from '../pages/Reports/MeetingDocumentsApprovalReport';
import ActivityLogReport from '../pages/Reports/ActivityLogReport';

import Frontend from '../helperComponents/Templates/frontend';
import Workflow from '../pages/Workflow/Circulation';
import Dashboard from '../pages/Dashboard';
import MainLayoutAlt from '../layout/mainLayoutAlternative';
import ESG from '../pages/ESG';
import RouteStyleTwo from './component/RouteStyleTwo';
import TextEditor from '../helperComponents/TextEditor';
import Templates from '../helperComponents/Templates';
import ProcessEnd from '../pages/Auth/SignUp/ProcessEnd';
import VerifyMail from '../pages/Auth/SignUp/VerifyMail';
import DayView from '../pages/MeetingManagement/MyCalandar/DayView';
import ApprovalRequest from '../pages/Workflow/ApprovalRequest';
import Circulation from '../pages/Workflow/Circulation';
import ViewCirculer from '../pages/Workflow/Circulation/ViewCirculer';
import InitiatorView from '../pages/Workflow/Circulation/InitiatorView';
import TemplateManager from '../pages/Workflow/TemplateManager';
import WorkflowManager from '../pages/Workflow/WorkflowManager';
import RequestedTypeManager from '../pages/Workflow/RequestedTypeManager';
import EditApprovalRequest from '../pages/Workflow/ApprovalRequest/EditApprovalRequest';
import PDFAnnotation from '../pages/PDFAnnotation';
import OtpOptions from '../pages/Auth/Otp/OtpOptions';
import OtpVerification from '../pages/Auth/Otp/OtpVerification';
import Unauthorized from './component/Unauthorized';
import ServerDown from './component/ServerDown';

function RoutesApp({ sendTheme, getTheme }) {

    return (
        <BrowserRouter>
            <Routes>
                <Route element={<RouteStyleOne />}>
                    <Route path="/" element={
                        <RequireNoAuth>
                            {/* <WelcomeScreen /> */}
                            <Login />
                        </RequireNoAuth>
                    } />
                    <Route path="/login" element={
                        <RequireNoAuth>
                            <Login />
                        </RequireNoAuth>
                    } />
                    <Route path="/otp-option" element={
                        <RequireNoAuth>
                            <OtpOptions />
                        </RequireNoAuth>
                    } />
                    <Route path="/verify-otp" element={
                        <RequireNoAuth>
                            <OtpVerification />
                        </RequireNoAuth>
                    } />
                    <Route path="/login/Meeting-Management/alt-reallocation/" element={
                        <RequireNoAuth>
                            <Login />
                        </RequireNoAuth>
                    } />
                    {/* <Route path="/register" element={
                        <RequireNoAuth>
                            <SignUp />
                        </RequireNoAuth>
                    } /> */}
                    <Route path="/process-end" element={
                        <RequireNoAuth>
                            <ProcessEnd />
                        </RequireNoAuth>
                    } />

                    <Route path="/verify-email" element={
                        <RequireNoAuth>
                            <VerifyMail />
                        </RequireNoAuth>
                    } />
                    <Route path="/changePassword/:tokenId?" element={<ChangePassword />} />
                    <Route path="/changePassword" element={<ChangePassword />} />
                    <Route path="/forgetPassword" element={<ForgetPassword />} />
                </Route>
                <Route element={<RouteStyleTwo />}>

                    <Route path="/ESG" element={
                        <RequireNoAuth>
                            <ESG />
                        </RequireNoAuth>
                    } />

                </Route>
                <Route path="/Home" element={<RequireJWT><MainLayout toggleTheme={() => { sendTheme(getTheme === "default" ? "dark" : "default"); localStorage.setItem('profileTheme', getTheme === "default" ? "dark" : "default"); }} getTheme={getTheme} /></RequireJWT>}>
                    <Route path="" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <Dashboard />
                        </RequireAuth>
                    } />
                </Route>
                <Route path="/MasterData" element={<RequireJWT><MainLayout toggleTheme={() => { sendTheme(getTheme === "default" ? "dark" : "default"); localStorage.setItem('profileTheme', getTheme === "default" ? "dark" : "default"); }} getTheme={getTheme} /></RequireJWT>}>
                    {/* <Route path="" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <Branch />
                        </RequireAuth>
                    } /> */}
                    <Route path="Branch" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <Branch />
                        </RequireAuth>
                    } />
                    <Route path="Department" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <Department />
                        </RequireAuth>
                    } />
                    <Route path="Role" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <Role />
                        </RequireAuth>
                    } />
                    <Route path="User" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <User />
                        </RequireAuth>
                    } />
                    <Route path="Committee-config" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <CommitteeConfig />
                        </RequireAuth>
                    } />
                    <Route path="/MasterData/bulk-upload" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <BulkUser />
                        </RequireAuth>
                    } />

                </Route>

                <Route path="/My-calendar" element={<RequireJWT><MainLayout toggleTheme={() => { sendTheme(getTheme === "default" ? "dark" : "default"); localStorage.setItem('profileTheme', getTheme === "default" ? "dark" : "default"); }} getTheme={getTheme} /></RequireJWT>}>
                    <Route path="" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <MyCalendar />
                        </RequireAuth>
                    } />
                </Route>
                <Route path="/My-calendar" element={<RequireJWT><MainLayout toggleTheme={() => { sendTheme(getTheme === "default" ? "dark" : "default"); localStorage.setItem('profileTheme', getTheme === "default" ? "dark" : "default"); }} getTheme={getTheme} /></RequireJWT>}>
                    <Route path="DayView" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <DayView />
                        </RequireAuth>
                    } />
                </Route>
                <Route path="/Meeting-Management" element={<RequireJWT><MainLayout toggleTheme={() => { sendTheme(getTheme === "default" ? "dark" : "default"); localStorage.setItem('profileTheme', getTheme === "default" ? "dark" : "default"); }} getTheme={getTheme} /></RequireJWT>}>
                    <Route path="Meetings" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <Meeting />
                        </RequireAuth>
                    } />
                    <Route path="Manage-committee" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <ManageCommittee />
                        </RequireAuth>
                    } />
                </Route>
                <Route path="/chat" element={<RequireJWT><MainLayout toggleTheme={() => { sendTheme(getTheme === "default" ? "dark" : "default"); localStorage.setItem('profileTheme', getTheme === "default" ? "dark" : "default"); }} getTheme={getTheme} /></RequireJWT>}>
                    <Route path="" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <ChatLayout />
                        </RequireAuth>
                    } />

                </Route>
                <Route path="/meeting-management" element={<RequireJWT><MainLayout toggleTheme={() => { sendTheme(getTheme === "default" ? "dark" : "default"); localStorage.setItem('profileTheme', getTheme === "default" ? "dark" : "default"); }} getTheme={getTheme} /></RequireJWT>}>
                    <Route path="Alt-signatory" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <AltSignatory />
                        </RequireAuth>
                    } />

                </Route>
                <Route path="/Workflow" element={<RequireJWT><MainLayout toggleTheme={() => { sendTheme(getTheme === "default" ? "dark" : "default"); localStorage.setItem('profileTheme', getTheme === "default" ? "dark" : "default"); }} getTheme={getTheme} /></RequireJWT>}>
                    <Route path="Workflow" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <Workflow />
                        </RequireAuth>
                    } />

                </Route>
                <Route path="/Leave-Management" element={<RequireJWT><MainLayout toggleTheme={() => { sendTheme(getTheme === "default" ? "dark" : "default"); localStorage.setItem('profileTheme', getTheme === "default" ? "dark" : "default"); }} getTheme={getTheme} /></RequireJWT>}>
                    <Route path="Leave-Management" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <LeaveManagement />
                        </RequireAuth>
                    } />
                </Route>

                <Route path="/Reports" element={<RequireJWT><MainLayout toggleTheme={() => { sendTheme(getTheme === "default" ? "dark" : "default"); localStorage.setItem('profileTheme', getTheme === "default" ? "dark" : "default"); }} getTheme={getTheme} /></RequireJWT>}>
                    <Route path="activity-report" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <ActivityLogReport />
                        </RequireAuth>
                    } />
                    <Route path="meeting-docs-report" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <MeetingDocsApprovalReport />
                        </RequireAuth>
                    } />
                </Route>
                <Route path="/Settings" element={<RequireJWT><MainLayout toggleTheme={() => { sendTheme(getTheme === "default" ? "dark" : "default"); localStorage.setItem('profileTheme', getTheme === "default" ? "dark" : "default"); }} getTheme={getTheme} /></RequireJWT>}>
                    <Route path="" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <SettingsLayout />
                        </RequireAuth>
                    } />
                </Route>
                <Route path="/meeting-management" element={<RequireJWT><MainLayoutAlt toggleTheme={() => { sendTheme(getTheme === "default" ? "dark" : "default"); localStorage.setItem('profileTheme', getTheme === "default" ? "dark" : "default"); }} getTheme={getTheme} /></RequireJWT>}>
                    <Route path="alt-reallocation" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <AltSignatoryRellocation />
                        </RequireAuth>
                    } />
                </Route>
                <Route path="/test" element={<RequireJWT><MainLayoutAlt toggleTheme={() => { sendTheme(getTheme === "default" ? "dark" : "default"); localStorage.setItem('profileTheme', getTheme === "default" ? "dark" : "default"); }} getTheme={getTheme} /></RequireJWT>}>
                    <Route path="text-editor" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <TextEditor />
                        </RequireAuth>
                    } />
                </Route>
                {/* 
                =============================================================================
                WORKFLOW ROUTES SECTION - CURRENTLY NOT IN USE
                =============================================================================
                TODO: When workflow functionality is needed, consolidate these duplicate routes:
                
                ISSUES FOUND:
                1. Multiple duplicate routes with same path "/work-flow" (lines 240-305)
                2. Inconsistent layout usage (MainLayout vs MainLayoutAlt)
                3. Should be consolidated into single route with multiple children
                
                REQUIRED CHANGES WHEN WORKFLOW IS ACTIVATED:
                1. Replace all duplicate "/work-flow" routes with single route
                2. Move all child routes under single parent route
                3. Standardize layout usage (choose either MainLayout or MainLayoutAlt)
                4. Test all workflow navigation items work correctly
                
                CURRENT DUPLICATE ROUTES TO CONSOLIDATE:
                - Line 240: templates
                - Line 247: testflow  
                - Line 254: template-manager
                - Line 261: workflow-manager
                - Line 268: request-approval
                - Line 275: circuler
                - Line 282: view-circuler
                - Line 289: initiator-view
                - Line 296: request-type
                - Line 303: edit-approval-request
                =============================================================================
                */}
                <Route path="/work-flow" element={<RequireJWT><MainLayoutAlt toggleTheme={() => { sendTheme(getTheme === "default" ? "dark" : "default"); localStorage.setItem('profileTheme', getTheme === "default" ? "dark" : "default"); }} getTheme={getTheme} /></RequireJWT>}>
                    <Route path="testflow" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <Frontend />
                        </RequireAuth>
                    } />
                </Route>
                <Route path="/work-flow" element={<RequireJWT><MainLayout toggleTheme={() => { sendTheme(getTheme === "default" ? "dark" : "default"); localStorage.setItem('profileTheme', getTheme === "default" ? "dark" : "default"); }} getTheme={getTheme} /></RequireJWT>}>
                    <Route path="template-manager" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <TemplateManager />
                        </RequireAuth>
                    } />
                </Route>
                <Route path="/work-flow" element={<RequireJWT><MainLayout toggleTheme={() => { sendTheme(getTheme === "default" ? "dark" : "default"); localStorage.setItem('profileTheme', getTheme === "default" ? "dark" : "default"); }} getTheme={getTheme} /></RequireJWT>}>
                    <Route path="workflow-manager" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <WorkflowManager />
                        </RequireAuth>
                    } />
                </Route>
                <Route path="/work-flow" element={<RequireJWT><MainLayout toggleTheme={() => { sendTheme(getTheme === "default" ? "dark" : "default"); localStorage.setItem('profileTheme', getTheme === "default" ? "dark" : "default"); }} getTheme={getTheme} /></RequireJWT>}>
                    <Route path="request-approval" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <ApprovalRequest />
                        </RequireAuth>
                    } />
                </Route>
                <Route path="/work-flow" element={<RequireJWT><MainLayout toggleTheme={() => { sendTheme(getTheme === "default" ? "dark" : "default"); localStorage.setItem('profileTheme', getTheme === "default" ? "dark" : "default"); }} getTheme={getTheme} /></RequireJWT>}>
                    <Route path="circuler" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <Circulation />
                        </RequireAuth>
                    } />
                </Route>
                <Route path="/work-flow" element={<RequireJWT><MainLayout toggleTheme={() => { sendTheme(getTheme === "default" ? "dark" : "default"); localStorage.setItem('profileTheme', getTheme === "default" ? "dark" : "default"); }} getTheme={getTheme} /></RequireJWT>}>
                    <Route path="view-circuler" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <ViewCirculer />
                        </RequireAuth>
                    } />
                </Route>
                <Route path="/work-flow" element={<RequireJWT><MainLayout toggleTheme={() => { sendTheme(getTheme === "default" ? "dark" : "default"); localStorage.setItem('profileTheme', getTheme === "default" ? "dark" : "default"); }} getTheme={getTheme} /></RequireJWT>}>
                    <Route path="initiator-view" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <InitiatorView />
                        </RequireAuth>
                    } />
                </Route>
                <Route path="/work-flow" element={<RequireJWT><MainLayout toggleTheme={() => { sendTheme(getTheme === "default" ? "dark" : "default"); localStorage.setItem('profileTheme', getTheme === "default" ? "dark" : "default"); }} getTheme={getTheme} /></RequireJWT>}>
                    <Route path="request-type" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <RequestedTypeManager />
                        </RequireAuth>
                    } />
                </Route>
                <Route path="/work-flow" element={<RequireJWT><MainLayout toggleTheme={() => { sendTheme(getTheme === "default" ? "dark" : "default"); localStorage.setItem('profileTheme', getTheme === "default" ? "dark" : "default"); }} getTheme={getTheme} /></RequireJWT>}>
                    <Route path="edit-approval-request" element={
                        <RequireAuth allowedRoles={['Company Admin']}>
                            <EditApprovalRequest />
                        </RequireAuth>
                    } />
                </Route>
                <Route element={<RouteStyleTwo />}>

                    <Route path="/pdf" element={
                        <RequireNoAuth>
                            <PDFAnnotation />
                        </RequireNoAuth>
                    } />

                </Route>
                <Route path="/unauthorized" element={<Unauthorized toggleTheme={() => { sendTheme(getTheme === "default" ? "dark" : "default"); localStorage.setItem('profileTheme', getTheme === "default" ? "dark" : "default"); }} getTheme={getTheme} />} />
                <Route path="/serverdown" element={<ServerDown toggleTheme={() => { sendTheme(getTheme === "default" ? "dark" : "default"); localStorage.setItem('profileTheme', getTheme === "default" ? "dark" : "default"); }} getTheme={getTheme} />} />
                <Route path="*" element={<NotFound />} />
                <Route path="*" element={<NotFound toggleTheme={() => { sendTheme(getTheme === "default" ? "dark" : "default"); localStorage.setItem('profileTheme', getTheme === "default" ? "dark" : "default"); }} getTheme={getTheme} />} />
            </Routes>
        </BrowserRouter>
    );
}

export default RoutesApp;
